import { create } from 'zustand';
import type { AdminResponseDto } from '@api/generated/model';

// 리셉션 모드 상태 (체크인 대상 대회/회차는 서버(Redis)에 함께 저장되어 내려옴)
export type ReceptionState = {
	active: boolean;
	managerName: string;
	expiresAt: number;
	contestId: string | null;
	sessionId: number | null;
	title: string | null;
};

// 리셉션 초기 상태
const initialReception: ReceptionState = {
	active: false,
	managerName: '',
	expiresAt: 0,
	contestId: null,
	sessionId: null,
	title: null
};

type AuthState = {
	// State
	admin: AdminResponseDto | null; // 관리자 정보
	accessToken: string | null;
	isAuthenticated: boolean; // 인증 여부
	isLoading: boolean; // 앱 부팅 시 로그인 세션 복원 중 여부
	reception: ReceptionState; // 리셉션 모드 상태
	// Action
	setAdmin: (admin: AdminResponseDto | null) => void;
	setAccessToken: (token: string | null) => void;
	setIsAuthenticated: (isAuthenticated: boolean) => void;
	setIsLoading: (isLoading: boolean) => void;
	setReception: (reception: ReceptionState) => void;
	clearReception: () => void;
	login: (admin: AdminResponseDto, accessToken: string) => void;
	logout: () => void;
	reset: () => void;
};

// 초기 상태
const initialState = {
	admin: null,
	accessToken: null,
	isAuthenticated: false,
	isLoading: true,
	reception: initialReception
};


export const useAuthStore = create<AuthState>()(set => ({
	...initialState,
	// setter 함수
	setAdmin: admin => set({ admin }),
	setAccessToken: accessToken => set({ accessToken }),
	setIsAuthenticated: isAuthenticated => set({ isAuthenticated }),
	setIsLoading: isLoading => set({ isLoading }),
	// 리셉션 모드 상태 갱신
	setReception: reception => set({ reception }),
	clearReception: () => set({ reception: initialReception }),
	// 로그인
	login: (admin, accessToken) =>
		set({
			admin,
			accessToken,
			isAuthenticated: true,
			isLoading: false
		}),
	// 로그아웃
	logout: () =>
		set({
			admin: null,
			accessToken: null,
			isAuthenticated: false,
			isLoading: false,
			reception: initialReception
		}),
	// 전체 초기화
	reset: () => set(initialState)
}));
